<template>
  <div class="CreatvallStyle">
    <div class="title">
      <span>直播列表</span>
    </div>
    <div class="buttonStyle">
      <span>播放状态：</span>
      <el-select v-model="searchData.playState" placeholder="按状态排序">
        <el-option v-for="item in playState" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="buttonStyle">
      <span>播放类型：</span>
      <el-select v-model="searchData.playType" placeholder="按状态排序">
        <el-option v-for="item in playType" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="buttonStyle">
      <span>选择播放日期：</span>
      <el-col :span="11">
        <el-date-picker v-model="searchData.startTime" format="yyyy-MM-dd hh:mm" value-format="yyyy-MM-dd hh:mm"
          type="date" placeholder="选择日期">
        </el-date-picker>
      </el-col>
      <el-col :span="11">
        <el-date-picker v-model="searchData.endTime" format="yyyy-MM-dd hh:mm" value-format="yyyy-MM-dd hh:mm"
          type="date" placeholder="选择日期">
        </el-date-picker>
      </el-col>
    </div>
    <div class="buttonStyle">
      <span>关键字搜索：</span>
      <el-input v-model="searchData.subject" class="suosuInput" placeholder="请输入内容"></el-input>
      <el-button type="primary" @click="tijioaClick">提交</el-button>
    </div>
    <div style="margin: 20px 0px 30px 0px;overflow: hidden;">
      <div v-for="(item, index) in dataArr" :class="{'ImgList':true, 'activeclass':BorderAvtive[index]}"
        @mouseenter="enter(index)" @mouseleave="leave(index)">
        <div class="card-top">
          <span class="card-status sub">
            <span v-if="item.playType === 1">直播</span>
            <span v-else-if="item.playType === 2">录播</span>
            <span v-else>链接</span>
          </span>
          <!-- <span class="card-status sub1" v-if="item.playType === 1">
            <span v-if="new Date() < item.createTime">预约中</span>
            <span v-else-if="item.endTime === null">直播进行中</span>
            <span v-else>结束</span>
          </span> -->
          <div class="typelabel">视频直播</div>
          <a @click="detailPageClick(item)">
            <img v-if="item.imgUrl" :src="item.imgUrl" alt="">
            <img v-else src="//cnstatic01.e.vhall.com/static/img/v35-webinar.png">
          </a>
          <span class="card-type hide">免费</span>
        </div>
        <div class="card-bottom">
          <p class="title">{{item.subject}}</p>
          <p class="info">
            <time>{{item.start_time}}</time><span id="pnum_701910079"><i></i>{{item.pv}}</span>
          </p>
          <div :class="{'btm-tool-bar':true, 'Hoveractiveclass':anmiantionAtive[index]}">
            <span v-if="item.playType === 1" @click="detailPageClick(item)"><a target="_blank"
                class="btn-live"><i></i>直播详情</a></span>
            <span @click="EditPageClick(item)" class="set"><a class=""><i></i>编辑</a></span>
            <span @click="onDelLive(item)" class="content"><a class="0"><i></i>删除</a></span>
            <!-- <span class="stat"><a class=""><i></i>数据</a></span> -->
          </div>
        </div>
      </div>
    </div>
    <el-pagination class="pagebutto" @current-change="handleCurrentChange" :current-page.sync="currPageNo"
      :page-size="pageSize" layout="prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import { netmettinglist, deleteRecord, deleteRecordLubo } from '@/api/VhallLive'
  import { showConfirm, toastSuccess } from '../../common/utils/ui'
  // 'status': 1, // 1:直播进行中,2:预约中,3:结束
  export default {
    name: 'LiveList',
    data() {
      return {
        playState: [
          { value: '1', label: '已结束' },
          { value: '2', label: '未开始' }
        ],
        playType: [
          { value: '1', label: '直播' },
          { value: '2', label: '录播' },
        ],
        searchData: {
          subject: '',
          startTime: '',
          endTime: '',
          playType: '',
          playState: ''
        },
        isactive: false,
        isactive2: false,
        currPageNo: 1,
        pageSize: 12,
        total: 10,
        dataArr: [],
        BorderAvtive: {},
        anmiantionAtive: {}
      }
    },
    created() {
    },
    mounted() {
      this.apiSend()
    },
    methods: {
      // 列表数据
      apiSend() {
        var obj = {
          currPageNo: this.currPageNo,
          pageSize: this.pageSize,
          total: this.total,
          subject: this.searchData.subject,
          startTime: this.searchData.startTime,
          endTime: this.searchData.endTime,
          playType: this.searchData.playType,
          playState: this.searchData.playState
        }
        netmettinglist(obj).then(response => {
        //   console.log(response)
          if (response.data) {
            this.dataArr = response.data.list
            this.total = response.data.total
            if (response.data.list.length > 0) {
              for (var i = 0; i < response.data.list.length; i++) {
                this.$set(this.BorderAvtive, i, false)
                this.$set(this.anmiantionAtive, i, false)
              }
            }
          }
        })
      },
      // 提交
      tijioaClick() {
        // console.log(this.searchData)
        this.apiSend()
      },
      // 分页
      handleCurrentChange(val) {
        this.currPageNo = val
        this.apiSend()
      },
      // 点击直播/直播详情 - 详情页
      detailPageClick(item) {
        if (item.playType === 1) {
          this.$router.push({ name: 'LiveDetail', params: { item: item } })
        } else {
          this.$message({
            message: '这是录播',
            type: 'warning'
          })
        }
      },
      // 编辑
      EditPageClick(item) {
        // console.log(item)
        if (item.playType === 2) {
          this.$router.push({ name: 'creatLubo', params: { item: item } })
        } else {
          this.$router.push({ name: 'CreatVhall', params: { item: item } })
        }
      },
        // 删除确认
        onDelLive (liveInfo) {
            const isLive = liveInfo.playType === 1 // 是否是直播
            const msg = isLive ? '确定要删除该直播吗' : '确定要删除该录播吗'
            showConfirm(msg, '删除确认').then(() => {
                this.ClickList(liveInfo)
            })
      },
      // 删除
      ClickList(item) {
        // console.log(item)

        var obj = {
          webinarId: item.webinarId
        }
        if (item.playType === 1) {
          deleteRecordLubo(obj).then(response => {
            // console.log(response)
            this.$message({
              message: '直播删除成功',
              type: 'success'
            })
            this.apiSend()
          })
        } else {
          deleteRecord(obj).then(response => {
            // console.log(response)
            this.$message({
              message: '录播删除成功',
              type: 'success'
            })
            this.apiSend()
          })
        }
      },
      // 鼠标进-动画效果
      enter(index) {
        this.BorderAvtive[index] = true
        this.anmiantionAtive[index] = true
      },
      // 鼠标出 - 动画效果
      leave(index) {
        this.BorderAvtive[index] = false
        this.anmiantionAtive[index] = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .CreatvallStyle {
    position: relative;
    height: 100%;
    width: 100%;

    .title {
      font-size: 20px;
      padding: 20px 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;

      a {
        text-decoration: none;
        color: black;
      }
    }

    .buttonStyle {
      margin-top: 20px;

      .suosuInput {
        width: 300px;
      }
    }

    .activeclass {
      border-color: #fc5659 !important;
    }

    .ImgList {
      float: left;
      width: 280px;
      height: 214px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
      border-radius: 2px;
      margin: 10px 10px;
      cursor: pointer;
      position: relative;

      .card-top {
        position: relative;
        padding: 9px;

        .sub {
          background-color: #5ea6ec;
          position: absolute;
          top: 10px;
          left: 18px;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          padding: 4px 8px;
          line-height: 16px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          /* width: 36px; */
        }

        .sub1 {
          background-color: #5ea6ec;
          position: absolute;
          top: 10px;
          left: 80px;
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          padding: 4px 8px;
          line-height: 16px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          /* width: 80px; */
        }

        .typelabel {
          position: absolute;
          bottom: 20px;
          left: 18px;
          border-radius: 13px;
          width: 67px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.7);
        }

        a {
          cursor: pointer;

          img {
            width: 260px;
            height: 145px;
            border: 1px solid #d2d2d2;
          }
        }

        .card-type {
          position: absolute;
          bottom: 20px !important;
          right: 18px !important;
          border-radius: 13px;
          height: 22px;
          line-height: 22px;
          text-align: center;
          font-size: 12px;
          color: #fff;
          background: rgba(0, 0, 0, 0.7);
          padding-left: 10px;
          padding-right: 10px;
        }
      }

      .card-bottom {
        position: relative;
        height: 50px;
        overflow: hidden;

        .title {
          padding-top: 3px;
          width: 278px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        .info {
          font-size: 12px;
          padding-bottom: 2;
          color: #999;

          #pnum_701910079 {
            float: right;

            i {
              float: left;
              width: 15px;
              height: 15px;
              background: url(../../assets/images/icon.png) no-repeat -17px -15px;
            }
          }
        }

        .btm-tool-bar {
          position: absolute;
          width: 100%;
          background: #000;
          opacity: 0.7;
          height: 50px;
          line-height: 50px;
          left: 0;
          bottom: -50px;
          -webkit-transition: all .3s ease-in-out;
          transition: all .3s ease-in-out;
          display: -webkit-flex;
          display: -ms-flex;
          display: -moz-flex;
          display: -webkit-box;
          display: flex;

          span {
            webkit-flex: 1;
            -moz-flex: 1;
            -webkit-box-flex: 1;
            flex: 1;
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #fff;
            font-size: 12px;

            a {
              color: #fff;
              display: inline-block;
              height: 100%;
              width: 100%;
              text-decoration: none;

              i {
                background-position: -37px -35px;
                width: 15px;
                height: 15px;
                display: inline-block;
                background: url(../../assets/images/icon.png) no-repeat -37px -15px;
                margin-right: 5px;
                position: relative;
                top: 3px;
              }
            }
          }

          .content {
            -webkit-flex: 1;
            -moz-flex: 1;
            -webkit-box-flex: 1;
            flex: 1;
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #fff;
            font-size: 12px;

            a {
              color: #fff;
              display: inline-block;
              height: 100%;
              width: 100%;
              text-decoration: none;

              i {
                background-position: -37px -55px;
                width: 15px;
                height: 15px;
                display: inline-block;
                background: url(../../assets/images/icon.png) no-repeat -37px -15px;
                margin-right: 5px;
                position: relative;
                top: 3px;
              }
            }
          }

          .stat {
            -webkit-flex: 1;
            -moz-flex: 1;
            -webkit-box-flex: 1;
            flex: 1;
            cursor: pointer;
            display: inline-block;
            text-align: center;
            color: #fff;
            font-size: 12px;

            a {
              color: #fff;
              display: inline-block;
              height: 100%;
              width: 100%;
              text-decoration: none;

              i {
                background-position: -37px -73px;
                width: 15px;
                height: 15px;
                display: inline-block;
                background: url(../../assets/images/icon.png) no-repeat -37px -15px;
                margin-right: 5px;
                position: relative;
                top: 3px;
              }
            }
          }
        }

        .Hoveractiveclass {
          bottom: 0px;
          -webkit-transition: all .3s ease-in-out;
          transition: all .3s ease-in-out;
        }
      }
    }

    .pagebutto {
      margin-left: 37%
    }
  }

  .CreatvallStyle .buttonStyle {
    display: flex;
  }

  .CreatvallStyle>>>.el-col-11 {
    width: 234px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/Live-list.vue